const MealEvent = {
  onSearch: 'meal/on-search'
}

export default MealEvent
